var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [_vm._v("容器管理")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "icon-fresh",
              attrs: { size: "mini", icon: "el-icon-refresh" },
              on: {
                click: function($event) {
                  return _vm.fetchData(true)
                }
              }
            },
            [_vm._v("刷新")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.resData
        ? _c(
            "div",
            {
              staticClass: "row",
              attrs: {
                gutter: 20,
                type: "flex",
                align: "middle",
                justify: "start"
              }
            },
            _vm._l(_vm.storehouseIds, function(item) {
              return item.key !== -1
                ? _c(
                    "div",
                    {
                      key: item.key,
                      staticClass: "status",
                      class: { active: _vm.origin === item.key },
                      on: {
                        click: function($event) {
                          return _vm.selectOrigin(item.key)
                        }
                      }
                    },
                    [_vm._v("\n      " + _vm._s(item.label) + "\n    ")]
                  )
                : _vm._e()
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [_vm._v(_vm._s(_vm.filterFold ? "展开筛选" : "收起筛选"))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "分箱ID" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.box_no,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "box_no", $$v)
                                    },
                                    expression: "form.box_no"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "内容" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.type_no,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "type_no", $$v)
                                    },
                                    expression: "form.type_no"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                attrs: { filterable: "", placeholder: "状态" },
                                model: {
                                  value: _vm.form.status,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "status", $$v)
                                  },
                                  expression: "form.status"
                                }
                              },
                              [
                                _c("el-option", { attrs: { value: "" } }, [
                                  _vm._v("全部")
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.status_list, function(item) {
                                  return _c("el-option", {
                                    key: item.key,
                                    attrs: {
                                      label: item.value,
                                      value: item.key
                                    }
                                  })
                                })
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                attrs: { filterable: "", placeholder: "组别" },
                                model: {
                                  value: _vm.form.group_id,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "group_id", $$v)
                                  },
                                  expression: "form.group_id"
                                }
                              },
                              [
                                _c("el-option", { attrs: { value: "" } }, [
                                  _vm._v("全部")
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.resData.group, function(item, key) {
                                  return _c("el-option", {
                                    key: key,
                                    attrs: { label: item, value: key }
                                  })
                                })
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                attrs: { filterable: "", placeholder: "类型" },
                                model: {
                                  value: _vm.form.type,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "type", $$v)
                                  },
                                  expression: "form.type"
                                }
                              },
                              _vm._l(_vm.resData.types, function(item, key) {
                                return _c("el-option", {
                                  key: key,
                                  attrs: { label: item, value: key }
                                })
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.search }
                                  },
                                  [_vm._v("查询")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { staticStyle: { border: "1px solid #ddd" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "50px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: { type: "success", size: "mini" },
                      on: {
                        click: function($event) {
                          _vm.manyVisible = true
                        }
                      }
                    },
                    [_vm._v("批量入库")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: { type: "danger", size: "mini" },
                      on: {
                        click: function($event) {
                          return _vm.unBand(0)
                        }
                      }
                    },
                    [_vm._v("批量解绑")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: {
                        click: function($event) {
                          _vm.bandVisible = true
                          _vm.title = "容器出库"
                          _vm.set_type = 1
                        }
                      }
                    },
                    [_vm._v("容器出库")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: {
                        click: function($event) {
                          _vm.bandVisible = true
                          _vm.title = "容器入库"
                          _vm.set_type = 2
                        }
                      }
                    },
                    [_vm._v("容器入库")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "margin-bottom": "0" } },
                [
                  _vm.resData
                    ? _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.tableLoading,
                              expression: "tableLoading"
                            }
                          ],
                          ref: "multipleTable",
                          staticStyle: { width: "100%" },
                          attrs: {
                            height: "800",
                            data: _vm.resData.list,
                            "tooltip-effect": "dark",
                            "cell-class-name": _vm.addColor
                          },
                          on: { "selection-change": _vm.handleSelectionChange }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "right",
                              type: "selection",
                              width: "55"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "分箱ID",
                              prop: "box_no",
                              "show-overflow-tooltip": "",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "group_name",
                              label: "组别"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "box_type",
                              label: "类型"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "type_no",
                              label: "绑定内容"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "status_text",
                              label: "状态"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "admin_name",
                              label: "更新人"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              prop: "update_time",
                              label: "更新时间"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              "show-overflow-tooltip": "",
                              align: "center"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            type: "text"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.unBand(
                                                scope.row.box_id
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("清除绑定")]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2409222252
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: _vm.title,
                    visible: _vm.bandVisible,
                    width: "60%",
                    center: "",
                    "close-on-click-modal": false,
                    "show-close": false
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.bandVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.form } },
                    [
                      _vm.set_type == 2
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "选择组别" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    filterable: "",
                                    placeholder: "选择组别"
                                  },
                                  model: {
                                    value: _vm.form.set_group_id,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "set_group_id", $$v)
                                    },
                                    expression: "form.set_group_id"
                                  }
                                },
                                _vm._l(_vm.resData.group, function(item, key) {
                                  return _c("el-option", {
                                    key: key,
                                    attrs: { label: item, value: key }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "输入箱号" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "70%", float: "left" },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.addNo.apply(null, arguments)
                              }
                            },
                            model: {
                              value: _vm.set_box_no,
                              callback: function($$v) {
                                _vm.set_box_no = $$v
                              },
                              expression: "set_box_no"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v("   " + _vm._s(_vm.box_num) + "个")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.box_nos, function(tag) {
                        return _c(
                          "el-tag",
                          {
                            key: tag,
                            attrs: {
                              closable: "",
                              "disable-transitions": false
                            },
                            on: {
                              close: function($event) {
                                return _vm.removeNo(tag)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " + _vm._s(tag) + "\n          "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.bandVisible = false
                              _vm.box_nos = []
                              _vm.box_num = 0
                            }
                          }
                        },
                        [_vm._v("取 消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        { attrs: { type: "primary" }, on: { click: _vm.band } },
                        [_vm._v("确 定")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "批量入库",
                    visible: _vm.manyVisible,
                    width: "60%",
                    center: "",
                    "close-on-click-modal": false,
                    "show-close": false
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.manyVisible = $event
                    }
                  }
                },
                [
                  _c(
                    "el-form",
                    { attrs: { model: _vm.form } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "选择组别" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                filterable: "",
                                placeholder: "选择组别"
                              },
                              model: {
                                value: _vm.form.set_group_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "set_group_id", $$v)
                                },
                                expression: "form.set_group_id"
                              }
                            },
                            _vm._l(_vm.resData.group, function(item, key) {
                              return _c("el-option", {
                                key: key,
                                attrs: { label: item, value: key }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "批量入库" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "30%", float: "left" },
                            attrs: { placeholder: "五位数字", maxlength: "5" },
                            model: {
                              value: _vm.first_num,
                              callback: function($$v) {
                                _vm.first_num = $$v
                              },
                              expression: "first_num"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                float: "left",
                                "margin-left": "5px",
                                "margin-right": "5px"
                              }
                            },
                            [_vm._v("至")]
                          ),
                          _vm._v(" "),
                          _c("el-input", {
                            staticStyle: { width: "30%", float: "left" },
                            attrs: { placeholder: "五位数字", maxlength: "5" },
                            model: {
                              value: _vm.end_num,
                              callback: function($$v) {
                                _vm.end_num = $$v
                              },
                              expression: "end_num"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.manyVisible = false
                            }
                          }
                        },
                        [_vm._v("取 消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.genMany }
                        },
                        [_vm._v("确 定")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.resData
                ? _c(
                    "div",
                    { staticStyle: { "text-align": "right", padding: "25px" } },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.curPage,
                          background: "",
                          layout: "total, prev, pager, next, jumper ,sizes",
                          total: _vm.resData.count,
                          "page-size": _vm.form.pagesize,
                          "page-sizes": [50, 100, 200, 500, 1000]
                        },
                        on: {
                          "update:currentPage": function($event) {
                            _vm.curPage = $event
                          },
                          "update:current-page": function($event) {
                            _vm.curPage = $event
                          },
                          "current-change": _vm.handleCurrentChange,
                          "size-change": _vm.handleSizeChange
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-989eb312", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-989eb312","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/storagebox/index.vue
// module id = null
// module chunks = 